import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { LOCKER_COUNTS_BY_PREFIX } from '../utils/moduleFormValidation';

// Example 2-column layout illustrating the SN picking order.
const DIAGRAM_COLUMNS = [
  [1, 2, 3],
  [4, 5, 6],
];

export default function ModuleHelpModal({ isOpen, toggle }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" className="module-help-modal">
      <ModalHeader toggle={toggle}>
        <i className="fas fa-info-circle mr-2"></i>
        Ayuda · Registro de módulo
      </ModalHeader>
      <ModalBody>

        {/* ── Reglas de taquillas ───────────────────── */}
        <div className="module-help-section">
          <div className="module-help-title">
            <i className="fas fa-list mr-2"></i>Taquillas y números de serie
          </div>
          <ul className="module-help-list">
            <li>
              Número de taquillas según el tipo:
              <br />
              <strong>VLM (módulo):</strong> {LOCKER_COUNTS_BY_PREFIX.VLM.join(', ')}
              <br />
              <strong>VLK (kiosco):</strong> {LOCKER_COUNTS_BY_PREFIX.VLK.join(', ')}
            </li>
            <li>El <strong>Nº de serie</strong> se compone de: prefijo (VLM/VLK) + nº de taquillas + serie. Solo tienes que elegir el prefijo y escribir la serie.</li>
            <li>Cada taquilla necesita un <strong>número de serie (SN)</strong> numérico y <strong>único</strong>.</li>
            <li><strong>No dejes ningún SN vacío</strong>: no podrás guardar hasta completarlos todos.</li>
            <li>Si dejas el <strong>PIN</strong> vacío se asignará <strong>2903</strong> automáticamente.</li>
          </ul>
        </div>

        {/* ── Orden de escaneo del SN ───────────────── */}
        <div className="module-help-section">
          <div className="module-help-title">
            <i className="fas fa-sort-amount-down mr-2"></i>Orden para introducir los SN
          </div>
          <p className="module-help-text">
            Introduce o escanea los SN <strong>columna por columna</strong>: empieza
            arriba y baja hasta el final de la columna; después pasa a la
            <strong> siguiente columna a la derecha</strong> y repite.
          </p>

          <div className="module-help-diagram" aria-hidden="true">
            {DIAGRAM_COLUMNS.map((col, ci) => (
              <React.Fragment key={ci}>
                <div className="module-help-column">
                  {col.map((n, ri) => (
                    <React.Fragment key={n}>
                      <div className="module-help-node">{n}</div>
                      {ri < col.length - 1 && (
                        <i className="fas fa-arrow-down module-help-down"></i>
                      )}
                    </React.Fragment>
                  ))}
                </div>
                {ci < DIAGRAM_COLUMNS.length - 1 && (
                  <div className="module-help-arrow">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          <div className="module-help-diagram-caption">Ejemplo: 6 taquillas en 2 columnas</div>

          <p className="module-help-warning">
            <i className="fas fa-exclamation-triangle mr-2"></i>
            Nunca cruces columnas, ni vayas de abajo a arriba o de derecha a izquierda.
          </p>
        </div>

      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggle}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
}
